export default "__VITE_ASSET__$zZOoCQ___"